/* eslint-disable react/prop-types */

import { sdGetStatusColour } from "helpers/sdHelper";
import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";



const SDStatusSelect = ({ initialValue, onUpdate, statuses }) => {
    const [selectedValue, setSelectedValue] = useState(initialValue);
    const [statusColours, setStatusColours] = useState({});

    useEffect(() => {
        let m = {};
        for (let i = 0; i < statuses.length; i++) {
            let status = statuses[i];
            m[status.id] = sdGetStatusColour(status.type)
        }
        console.log("m", m);
        setStatusColours(m);
    }, []);

    const handleChange = async (e) => {
        const newValue = e.target.value;
        setSelectedValue(newValue);
        onUpdate(newValue);
    };

    return (
        <><Form.Select aria-label="Default select example" value={selectedValue} onChange={handleChange} style={{ backgroundColor: statusColours[selectedValue] }}>
            {statuses.map((status) => (
                <option key={status.id} value={status.id} style={{ backgroundColor: statusColours[status.id] }}>
                    {status.name}
                </option>
            ))}

        </Form.Select></>
    );
}

export default SDStatusSelect;